module.exports = __webpack_public_path__ + "static/img/3.4549e94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhongzaisheng/detail0/3.png
// module id = cCTV
// module chunks = 19